import ReactModal from 'react-modal'

import './MobileNavTransition.css'
import NavBar from '../NavBar'
import { Auth0User } from '../../../types'

type MobileNavProps = {
  /** Whether the user is currently authenticated, from useAuth0 */
  isAuthenticated: boolean
  /** Whether nav menu is expanded over page content */
  isExpanded: boolean
  /** A function to expand nav menu over page content */
  onExpand: () => void
  /** A function to shrink the menu back to its default width */
  onShrink: () => void
  /** User object from useAuth0 */
  user?: Auth0User | undefined
}

const MobileNavBar = ({
  isAuthenticated,
  isExpanded,
  onExpand,
  onShrink,
  user
}: MobileNavProps) => {
  const fixed: 'fixed' = 'fixed'

  const contentClassName = {
    base: 'MobileNav__Content',
    afterOpen: 'MobileNav__Content--after-open',
    beforeClose: 'MobileNav__Content--before-close'
  }

  const overlayClassName = {
    base: 'MobileNav__Overlay',
    afterOpen: 'MobileNav__Overlay--after-open',
    beforeClose: 'MobileNav__Overlay--before-close'
  }

  const modalStyles = {
    overlay: {
      background: 'rgba(0,0,0,0.3)',
      border: 0,
      padding: 0,
      position: fixed,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      overflow: 'hidden'
    },
    content: {
      background: 'rgba(0, 0, 0, 0)',
      position: fixed,
      overflow: 'hidden',
      border: 0,
      padding: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  }

  /** react-modal overlay onClick callback.
   * https://reactcommunity.org/react-modal/examples/should_close_on_overlay_click/ */
  const handleRequestClose = () => onShrink()

  return (
    <ReactModal
      className={contentClassName}
      closeTimeoutMS={400}
      isOpen={isExpanded}
      onRequestClose={handleRequestClose}
      overlayClassName={overlayClassName}
      shouldCloseOnOverlayClick
      style={modalStyles}
    >
      <NavBar
        isAuthenticated={isAuthenticated}
        isPersisted
        isExpanded={isExpanded}
        onExpand={onExpand}
        onShrink={onShrink}
        user={user}
      />
    </ReactModal>
  )
}

export default MobileNavBar
